import React from "react";
import { history, logMessageToChatRoom } from './global';

class RNListener extends React.Component {
  componentDidMount() {
    if (window.isReactNative) {
      window.addEventListener("message", this.receiveRNMessage);      // Work on iOS
      document.addEventListener("message", this.receiveRNMessage);    // Work on Android
    }
  }

  componentWillUnmount() {
    if (window.isReactNative) {
      window.removeEventListener("message", this.receiveRNMessage);
      document.removeEventListener("message", this.receiveRNMessage);
    }
  }

  receiveRNMessage = (event) => {
    // if (event.data.startsWith("DN"))
    //   recognizeQRCode(event.data);
    // else 

    if (event.data.startsWith("NetworkStatus_")) {
      window.NetworkStatus = event.data.substring(14);
      if (window.updateKioskHeader)
        window.updateKioskHeader();
    }
    // else if (event.data.startsWith("OfflineData_")) //get local data
    //   window.OfflineData = event.data.substring(12);
    // else if (event.data.startsWith("WithOfflineData_")) { //check whether there is any local data
    //   var data = event.data.substring(16);
    //   var dataArray = data.split('_');
    //   window[dataArray[0]] = dataArray[1];
    // }
    // else if (event.data.startsWith("LastUpdateDate_"))
    //   window.LastUpdateDate = event.data.substring(15);
    else if (event.data == "RefreshWebView") {
      window.location.reload(true);
    }

  }

  render() {
    return '';
  }
}

const wait = (heartbeat, callback) => {

  setTimeout(() => {

    if (window.waitingMessage)
      wait(heartbeat, callback);
    else {
      callback();
    }

  }, heartbeat);
}

export const checkIsOffline = function () {
  return window.NetworkStatus == "Offline";
}


const getOfflineDataCallback = (event) => {
  if (!event.data.startsWith("OfflineData_")) return;
  window.OfflineData = event.data.substring(12);
  delete window.waitingMessage;
  window.removeEventListener("message", getOfflineDataCallback);
};


export const getOfflineData = function (dataKey) {

  if (window.isReactNative) {
    window.addEventListener("message", getOfflineDataCallback);
    window.waitingMessage = true;
    window.ReactNativeWebView.postMessage(`GetOfflineData_${dataKey}`);
  }

  var promise = new Promise(function (resolve, reject) {
    // setTimeout(() => {
    //   resolve(window.OfflineData);
    // }, 500);

    wait(50, () => {
      resolve(window.OfflineData);
    })

  });
  return promise;
}



const getGetLastUpdateDateCallback = (event) => {
  if (!event.data.startsWith("LastUpdateDate_")) return;
  window.LastUpdateDate = event.data.substring(15);
  delete window.waitingMessage;
  window.removeEventListener("message", getGetLastUpdateDateCallback);
};


export const getLastUpdateDate = function (dataKey) {

  if (window.isReactNative) {
    window.addEventListener("message", getGetLastUpdateDateCallback);
    window.waitingMessage = true;
    window.ReactNativeWebView.postMessage(`GetLastUpdateDate_${dataKey}`);
  }

  var promise = new Promise(function (resolve, reject) {
    // setTimeout(() => {
    //   resolve(window.LastUpdateDate);
    // }, 250);

    wait(50, () => {
      resolve(window.LastUpdateDate);
    })

  });
  return promise;
}









const checkOfflineKeyCallback = (event) => {
  if (!event.data.startsWith("WithOfflineData_")) return;
  var data = event.data.substring(16);
  var dataArray = data.split('_');
  window[dataArray[0]] = dataArray[1];

  // delete window.waitingMessage;
  if (window.checkOfflineKeyCount)
    window.checkOfflineKeyCount--;

  if (window.checkOfflineKeyCount == 0) {
    delete window.waitingMessage;
    delete window.checkOfflineKeyCount;
    window.removeEventListener("message", checkOfflineKeyCallback);
  }
};

export const checkOfflineKey = function (dataKey) {

  if (window.isReactNative) {
    window.addEventListener("message", checkOfflineKeyCallback);
    window.waitingMessage = true;

    if (!window.checkOfflineKeyCount)
      window.checkOfflineKeyCount = 1;
    else
      window.checkOfflineKeyCount++;
    window.ReactNativeWebView.postMessage(`CheckOfflineKey_${dataKey}`);
  }

  var promise = new Promise(function (resolve, reject) {
    wait(50, () => {
      let result = window[dataKey];
      delete window[dataKey];
      resolve(result);
    });

  });
  return promise;
}

export const saveOfflineData = function (values) {
  if (window.isReactNative) {
    window.ReactNativeWebView.postMessage("SaveOfflineData_" + JSON.stringify(values));
  }
}

export const removeOfflineData = function (dataKey) {
  if (window.isReactNative) {
    window.ReactNativeWebView.postMessage(`RemoveOfflineData_${dataKey}`);
  }
}

export const recognizeQRCode = (res) => {
  if (res.length > 2 && res.substring(0, 2) == "DN") {
    window.ReactNativeWebView.postMessage("ScanSuccess")

    setTimeout(() => {
      history.push({
        pathname: "/Kiosk/Home/GRNMarkPO/GRNDetails",
        state: { DNNo: res, SourceType: "PO" }
      });
    }, 500)


  } else {
    window.ReactNativeWebView.postMessage("ScanFailure")
  }
}


const getOfflineDataKeyCallback = (event) => {
  if (!event.data.startsWith("OfflineDataKeys_")) return;
  window.OfflineDataKeys = event.data.substring(16);
  delete window.waitingMessage;
  window.removeEventListener("message", getOfflineDataKeyCallback);
};


export const getOfflineDataKeys = function () {

  if (window.isReactNative) {
    window.addEventListener("message", getOfflineDataKeyCallback);
    window.waitingMessage = true;
    window.ReactNativeWebView.postMessage(`GetOfflineDataKeys`);
  }

  var promise = new Promise(function (resolve, reject) {

    wait(50, () => {
      resolve(window.OfflineDataKeys);
    })

  });
  return promise;
}
export default RNListener;


// WEBPACK FOOTER //
// ./src/reactNativeListener.js